import { render, staticRenderFns } from "./IntegrationsValueLookupsForm.vue?vue&type=template&id=b6e1ee6a&scoped=true"
import script from "./IntegrationsValueLookupsForm.vue?vue&type=script&lang=js"
export * from "./IntegrationsValueLookupsForm.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsValueLookupsForm.vue?vue&type=style&index=0&id=b6e1ee6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e1ee6a",
  null
  
)

export default component.exports